import {Component, inject, input, Input, InputSignal, Signal} from '@angular/core';
import {
  OccupationOfLanePlacementConstructionObjectsForm
} from '../../forms/occupation-of-lane-placement-construction-objects.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  LocationDecisionsCrudComponent
} from '../../../../../common/components/location-decisions/location-decisions-crud/location-decisions-crud.component';
import { TabPanelComponent } from '../../../../../../../../common/tab-view/tab-panel.component';
import { TabViewComponent } from '../../../../../../../../common/tab-view/tab-view.component';
import {
  OccupationOfLanePlacementConstructionObjectsStageFormComponent
} from '../occupation-of-lane-placement-construction-objects-stage-form/occupation-of-lane-placement-construction-objects-stage-form.component';
import {RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee} from "../../../../../../../../openapi";
import {selectPurposeFeeCollection} from "../../../../../../../../store/selectors/application.selectors";
import {Store} from "@ngrx/store";

@Component({
  selector: 'app-occupation-of-lane-placement-construction-objects-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    LocationDecisionsCrudComponent,
    TabPanelComponent,
    TabViewComponent,
    OccupationOfLanePlacementConstructionObjectsStageFormComponent
  ],
  templateUrl: './occupation-of-lane-placement-construction-objects-form.component.html'
})
export class OccupationOfLanePlacementConstructionObjectsFormComponent {

  private store$: Store = inject(Store);

  public serviceId: InputSignal<string | null> = input<string | null>(null);

  public applicationId: InputSignal<string | null> = input<string | null>(null);

  public purposeFeeCollection: Signal<RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[]> = this.store$.selectSignal(selectPurposeFeeCollection);

  @Input()
  public form: OccupationOfLanePlacementConstructionObjectsForm | undefined;
}
